import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1600); // show after Hero fade
    return () => clearTimeout(timer);
  }, []);

  return (
    <header className={`header-container ${visible ? 'fade-in-smooth' : 'hidden'}`}>
      <div className="header-logo">Amaan Siddiqi</div>
      <nav className="header-nav">
        {['/', '/about', '/projects', '/contact'].map((path, i) => {
          const label = ['Home', 'About', 'Projects', 'Contact'][i];
          return (
            <Link 
              key={path} 
              to={path} 
              className={location.pathname === path ? 'active' : ''}
            >
              {label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}

export default Header;
